import { SHOW_MODAL, HIDE_MODAL, SHOW_PREVIOUS_MODAL } from './types';

export const showModal = (modalType, modalProps) => ({
    type: SHOW_MODAL,
    modalType,
    modalProps,
});

export const hideModal = () => ({
    type: HIDE_MODAL,
});

export const showPreviousModal = () => ({
    type: SHOW_PREVIOUS_MODAL,
});
